import { render, staticRenderFns } from "./UserSideModal.vue?vue&type=template&id=2132c24c&scoped=true&"
import script from "./UserSideModal.vue?vue&type=script&lang=ts&"
export * from "./UserSideModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserSideModal.vue?vue&type=style&index=0&id=2132c24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132c24c",
  null
  
)

export default component.exports